import React from "react";
import { Link } from "react-router-dom";
import "./Services.css";
import { services, partners, stats, process } from '../data/site';

const Services = () => {
  return (
    <div className="services-page page-shell">
      <section className="services-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">Services</span>
          <h1>
            Nine practices. <span className="gradient-text serif-accent">One operating system</span> for AI &amp; data.
          </h1>
          <p>
            From CFO-ready strategy and platform engineering to deeply regulated production AI systems,
            Dalytix services are built to compound — connected through one delivery model and shared
            playbooks.
          </p>
          <div className="services-hero-actions">
            <Link to="/request-demo" className="btn-primary-large">Book Consultation</Link>
            <Link to="/case-studies" className="btn-ghost btn-arrow">View outcomes</Link>
          </div>

          <div className="services-hero-meta">
            {stats.practice.map((s) => (
              <div key={s.label}>
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="site-container-wide">
          <div className="section-head-row">
            <div>
              <span className="section-eyebrow">Capabilities</span>
              <h2 className="section-title">Practices designed for serious enterprise transformation.</h2>
            </div>
            <Link to="/request-demo" className="btn-outline btn-arrow">Talk to a partner</Link>
          </div>

          <div className="services-list">
            {services.map((service) => (
              <article key={service.id} className="service-detail-card professional-card">
                <div className="service-detail-icon">{service.icon}</div>
                <div className="service-detail-body">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <div className="service-deliverables">
                    {service.deliverables.map((d) => (<span key={d}>{d}</span>))}
                  </div>
                  <Link to={`/services/${service.id}`} className="learn-more">Explore practice →</Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section process-section section-dark">
        <div className="site-container-wide">
          <div className="section-head-row">
            <div>
              <span className="section-eyebrow">Delivery Model</span>
              <h2 className="section-title">Six stages from idea to long-term ownership.</h2>
            </div>
            <p className="section-lead-inline">No vendor lock-in. No key-person risk. Your team owns the outcome.</p>
          </div>
          <div className="process-grid services-process-grid">
            {process.map((p) => (
              <article className="process-card services-process-card" key={p.step}>
                <span>{p.step}</span>
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section service-platforms">
        <div className="site-container-wide">
          <div className="section-head-row">
            <div>
              <span className="section-eyebrow">Technology Stack</span>
              <h2 className="section-title">Cloud and data platforms your teams already trust.</h2>
            </div>
          </div>
          <div className="platform-grid">
            {partners.map((p) => (<span className="platform-pill" key={p}>{p}</span>))}
          </div>
        </div>
      </section>

      <section className="services-cta">
        <div className="site-container-wide professional-card">
          <h2>Need help choosing the right roadmap?</h2>
          <p>Tell us your business challenge. We will recommend a practical delivery path — usually within 48 hours.</p>
          <div className="hero-actions">
            <Link to="/contact" className="btn-primary-large">Talk to Dalytix</Link>
            <Link to="/insights" className="btn-outline btn-arrow">Read the briefing</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
